import { checkAnyPermission, checkPermission, permissionType } from "../common/Functions";

const PM = permissionType.PROJECT_MANAGEMENT;

export const PROJECT_BOARD_PERMISSION = {
  READ: "read",
  CREATE: "create",
  UPDATE: "update",
  DELETE: "delete",
  CREATE_BOARD: "create board",
  CREATE_LIST: "create list",
  ADD_CARD: "add card",
  EDIT_CARD: "edit card",
};

export const canReadProjectBoard = () =>
  checkPermission(PM, PROJECT_BOARD_PERMISSION.READ);

export const canCreateProjectBoard = () =>
  checkAnyPermission(PM, [
    PROJECT_BOARD_PERMISSION.CREATE_BOARD,
    PROJECT_BOARD_PERMISSION.CREATE,
  ]);

export const canCreateProjectList = () =>
  checkAnyPermission(PM, [
    PROJECT_BOARD_PERMISSION.CREATE_LIST,
    PROJECT_BOARD_PERMISSION.CREATE,
  ]);

export const canAddProjectCard = () =>
  checkAnyPermission(PM, [
    PROJECT_BOARD_PERMISSION.ADD_CARD,
    PROJECT_BOARD_PERMISSION.CREATE,
  ]);

export const canEditProjectCard = () =>
  checkAnyPermission(PM, [
    PROJECT_BOARD_PERMISSION.EDIT_CARD,
    PROJECT_BOARD_PERMISSION.UPDATE,
    PROJECT_BOARD_PERMISSION.READ,
  ]);

export const canManageProjectCard = () =>
  checkAnyPermission(PM, [
    PROJECT_BOARD_PERMISSION.EDIT_CARD,
    PROJECT_BOARD_PERMISSION.UPDATE,
  ]);

export const canUpdateProjectBoard = () =>
  checkPermission(PM, PROJECT_BOARD_PERMISSION.UPDATE);

export const canDeleteProjectBoard = () =>
  checkPermission(PM, PROJECT_BOARD_PERMISSION.DELETE);

/** Delete card uses the same manage permission as full card edits. */
export const canDeleteProjectCard = () => canManageProjectCard();
